var _defs, _rect, _rect2, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNoname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "12b15f96e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 194.695312 L 301.789062 194.695312 L 301.789062 209.710938 L 36 209.710938 Z M 36 194.695312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "79f5f59755"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.023438 87.675781 L 125.515625 87.675781 L 125.515625 111.445312 L 69.023438 111.445312 Z M 69.023438 87.675781 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#053d5d",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f8f8f8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.541343, 281.999981)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.59375 0 L 22.59375 -178.203125 L 30.375 -178.203125 L 30.375 -94.375 L 144.328125 -94.375 L 144.328125 -178.203125 L 152.109375 -178.203125 L 152.109375 0 L 144.328125 0 L 144.328125 -87.34375 L 30.375 -87.34375 L 30.375 0 Z M 22.59375 0 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8f8f8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.148874, 281.999981)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 30.375 0 L 22.59375 0 L 22.59375 -178.203125 L 75.296875 -178.203125 C 94.546875 -178.203125 109.523438 -173.894531 120.234375 -165.28125 C 130.941406 -156.664062 136.296875 -144.660156 136.296875 -129.265625 C 136.296875 -94.628906 113.875 -77.3125 69.03125 -77.3125 L 30.375 -77.3125 Z M 73.046875 -171.4375 L 30.375 -171.4375 L 30.375 -84.34375 L 69.28125 -84.34375 C 89.863281 -84.34375 104.878906 -87.851562 114.328125 -94.875 C 123.785156 -101.90625 128.515625 -113.285156 128.515625 -129.015625 C 128.515625 -143.566406 123.910156 -154.273438 114.703125 -161.140625 C 105.503906 -168.003906 91.617188 -171.4375 73.046875 -171.4375 Z M 73.046875 -171.4375 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#12b15f96e2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#053d5d",
    d: "M 36 194.695312 L 301.785156 194.695312 L 301.785156 209.710938 L 36 209.710938 Z M 36 194.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#79f5f59755)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#053d5d",
    d: "M 69.023438 87.675781 L 125.480469 87.675781 L 125.480469 111.445312 L 69.023438 111.445312 Z M 69.023438 87.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoname);
export default __webpack_public_path__ + "static/media/logoNoname.2616250cf3933fa65f4a5c3892c4a2a3.svg";
export { ForwardRef as ReactComponent };